import React from 'react';
import styled from 'styled-components';
import { Card } from 'styleguide/Card';
import { DoubleCircledIcon } from 'styleguide/CircledIcons';
import { P1, P2 } from 'styleguide/Texts';
import { Spacing } from 'styleguide/spacing';
import { t } from 'translations/t';

const Container = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${Spacing.md}px 0px ${Spacing.lg}px 0px;
  height: 240px;
`;

interface Props {
  username: string;
}

export const PrivateProfile = ({ username }: Props) => {
  return (
    <>
      <P1 style={{ marginTop: Spacing.lg }}>{t('global.workouts')}</P1>
      <Container>
        <DoubleCircledIcon
          containerStyle={{ marginBottom: Spacing.md }}
          type="lock"
        ></DoubleCircledIcon>
        <P1 style={{ textAlign: 'center', paddingBottom: Spacing.sm }}>
          {t('web.profile.privateProfile.privateProfile', { username })}
        </P1>
        <P2 style={{ textAlign: 'center' }} type="secondary">
          {t('web.profile.privateProfile.mustApproveToSee')}
        </P2>
      </Container>
    </>
  );
};
